export default {slug_name:'serarch_info',type:'search',version:'0.0.1',author:'Answer'};